import React, { ComponentType } from 'react';
import { Redirect } from 'react-router';

import { dynamicSelector } from 'modules/shared-cms-advanced/utils';

import { NavigationElement, Node } from 'modules/shared/models';
import { concatUrl } from 'modules/shared/utils';
import { StructureNavigationProps } from 'modules/shared/types';
import { NotifiedRoute as Route } from 'modules/shared/components';

const buildCurrentNavigationTree = (node: Node, parentNavigationTree?: NavigationElement): NavigationElement => {
    const path = node.pathId ? node.pathId : node.path;
    return {
        name: node.name && !node.isModuleEntry ? node.name : undefined,
        path: concatUrl([
            parentNavigationTree && parentNavigationTree.path ? parentNavigationTree.path : '/',
            path || '',
        ]),
        parent: parentNavigationTree,
        isModule: node.isModuleEntry || node.isSubModuleEntry,
        bannerId: node.bannerId,
    };
};

export const buildRoutesFromStructure = (
    StaticSelector: ComponentType<StructureNavigationProps>,
    items?: Node[],
    navigationTree?: NavigationElement,
    Layout?: ComponentType,
    isRoot?: boolean,
    exact?: boolean,
): JSX.Element => {
    if (!items || items.length === 0) {
        return <React.Fragment />;
    }

    return (
        <React.Fragment>
            {items.map((childItem: Node, key: number) => {
                const currentNavigationTree = buildCurrentNavigationTree(childItem, navigationTree);

                let exactMatch;
                if (
                    exact &&
                    childItem.contentTemplate &&
                    childItem.contentId &&
                    dynamicSelector(childItem.contentTemplate, childItem.contentId)
                ) {
                    exactMatch = true;
                }

                return (
                    // eslint-disable-next-line react/no-array-index-key
                    <React.Fragment key={key}>
                        {!childItem.isModuleEntry &&
                            buildRoutesFromStructure(
                                StaticSelector,
                                childItem.nodes,
                                currentNavigationTree,
                                Layout,
                                false,
                                exact,
                            )}
                        {!childItem.isShortcut && !childItem.isDynamic && (
                            <Route
                                structureNode={childItem}
                                navigationTree={currentNavigationTree}
                                exact={isRoot ? true : exactMatch}
                                path={currentNavigationTree.path}
                                render={() => {
                                    if (childItem.isRedirect && childItem.contentTemplate) {
                                        return <Redirect to={childItem.contentTemplate} />;
                                    }

                                    let content: JSX.Element | undefined;
                                    if (childItem.contentTemplate && childItem.contentId) {
                                        content = dynamicSelector(childItem.contentTemplate, childItem.contentId);
                                    }
                                    if (!content) {
                                        content = (
                                            <StaticSelector
                                                id={childItem.contentId || ''}
                                                template={childItem.contentTemplate || ''}
                                                sourceStructureNode={childItem}
                                                navigationTree={currentNavigationTree}
                                            />
                                        );
                                    }

                                    if (Layout && !childItem.isModuleEntry) {
                                        content = <Layout>{content}</Layout>;
                                    }

                                    return content;
                                }}
                            />
                        )}
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    );
};
